var _tacho_colors = ['#004b79', '#004b79', '#004b79', '#982e30'];

//var _signal_group_colors = {};
//_signal_group_colors[18] = ['#319662'];
//_signal_group_colors[19] = ['#EC450D'];
//_signal_group_colors[20] = ['#0A3BA3'];



